import React from 'react';

// Bootstyrap Imports
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

// Animation on Scroll
import Zoom from 'react-reveal/Zoom';

const Training = () => {
	// Component Functions
	const courses = [
		{
			img: '/img/de-la-venta-tradicional-a-la-digital.jpg',
			title: 'De la venta tradicional a la venta Digital',
			subTitle: 'En un click',
			btnLink: '/home',
		},
		{
			img: '/img/funnels-course.jpg',
			title: 'Embudos de ventas',
			subTitle: 'Un imán para atraer clientes',
			btnLink: '/home',
			filter: {
				position: 'absolute',
				top: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.3)',
				width: '100%',
				height: 200,
				borderRadius: '20px 20px 0 0',
			},
		},
		{
			img: '/img/marca-personal.jpg',
			title: '¿Cuál es tu marca digital?',
			subTitle: 'Construye tu huella',
			btnLink: '/home',
		},
	];

	return (
		<div className='mx-md-5 mb-4 px-md-5'>
			<Container className='text-center mb-3'>
				<h1>Cursos Online</h1>
				<div className='d-flex justify-content-center'>
					<div className='divider' />
				</div>
				<div className='mt-4'>
					<div className='courses-grid'>
						{courses.map((course, i) => (
							<Zoom key={i}>
								<div>
									<Card className='course-card'>
										<div style={{ position: 'relative' }}>
											<Card.Img
												variant='top'
												src={course.img}
												style={{
													maxHeight: 200,
													borderRadius: '20px 20px 0 0',
													objectFit: 'cover',
												}}
											/>
											<div style={course.filter} />
										</div>
										<Card.Body className='d-flex flex-column justify-content-between'>
											<Card.Title className='title text-left mb-0'>
												{course.title}
											</Card.Title>
											<p className='subtitle-important text-left'>
												{course.subTitle}
											</p>
											<button className='action-button full-width'>
												Ver más detalles
											</button>
										</Card.Body>
									</Card>
								</div>
							</Zoom>
						))}
					</div>
				</div>
			</Container>
		</div>
	);
};

export default Training;
